import  ReactDOM  from "react-dom"
import React, {lazy,Suspense} from 'react'
import './svr-bootstrap-v1.2.8/css/espace-bootstrap.css'
//import  './neon/libs/1.4/jquery/1.7.2/jquery.min.js'

/*
import App from './App'
import * as serviceWorker from './serviceWorker';

import {Provider} from 'react-redux'
import svcreateStore from './svstore'
 const ic = {
   "name":"svstart"
 }
 const store = svcreateStore(ic)
*/

 import * as serviceWorker from './serviceWorker'
 
 
 const DefaultRoot = require('./Root').default

 ReactDOM.render(<DefaultRoot />,
  document.getElementById('root')
)

/*
 import { Provider } from 'react-redux'
 import configureStore from './store'
 
 const store = configureStore();
 ReactDOM.render(<Provider store={store}>
 <App />
 </Provider>,
 document.getElementById('root'));
 */
 // If you want your app to work offline and load faster, you can change
 // unregister() to register() below. Note this comes with some pitfalls.
 // Learn more about service workers: https://bit.ly/CRA-PWA
 serviceWorker.unregister();
 